import { render, staticRenderFns } from "./commoditySingle.vue?vue&type=template&id=594704ba&scoped=true&"
import script from "./commoditySingle.vue?vue&type=script&lang=js&"
export * from "./commoditySingle.vue?vue&type=script&lang=js&"
import style0 from "./commoditySingle.vue?vue&type=style&index=0&id=594704ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "594704ba",
  null
  
)

export default component.exports